<template>
  <section class="closefriend-hero h-100" >
    <b @click="slideBar()" :class="showSlideBar ? 'screen-overlay show' : 'screen-overlay'"></b>
    <influencer-menu @menuClicked="slideBar()" :show-slide-bar="showSlideBar"></influencer-menu>
    <header-menu @slideMenu="slideBar()" :is-loading="isLoading"></header-menu>

    <div class="container-fluid mt-3">
      <div class="row justify-content-center">
        <div class="col-12 px-2 px-md-4" style="max-width: 1200px;">
          <div class="mx-auto mb-3 px-1">
            <global-message></global-message>

            <!-- Header with Add Content Button -->
            <div class="d-flex flex-wrap align-items-center justify-content-between mb-4 mt-2 px-1 gap-2">
              <div>
                <h5 class="text-white font-weight-700 mb-0 font-size-20">Bonus Content</h5>
                <span class="text-muted font-size-12">{{ contents.length }} items shared</span>
              </div>
              <button type="button" class="cp-btn-primary d-inline-flex align-items-center" @click="$router.push({name: 'BonusContentAdd'})">
                <i class="fa fa-plus me-2 font-size-12"></i> Add Content
              </button>
            </div>

            <!-- New Subscribers Notification Banner -->
            <div class="mb-3" v-if="isSubscriber">
              <div class="gradient-a border-radius-10 w-100">
                <div class="bg-animation d-flex p-3 px-3 align-items-center justify-content-between">
                  <div class="d-flex align-items-center">
                    <img class="img-fluid me-2" src="@/assets/images/stella/dash-side-icon.svg">
                    <span class="text-dark font-weight-800 font-size-16">You have new subscribers</span>
                  </div>
                  <div class="d-flex align-items-center">
                    <img class="img-fluid ms-1 cursor-pointer" src="@/assets/images/stella/arrow-simple-right-black.svg"
                         @click="goToNewSubscription()">
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Skeleton Loading Grid -->
          <div v-if="isLoading && contents.length === 0" class="content-grid">
            <div v-for="i in 6" :key="'skeleton-' + i" class="grid-cell" style="background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.06); animation: pulse 1.5s infinite; min-height: 220px;">
              <div class="d-flex flex-column justify-content-between h-100 p-3">
                <div class="d-flex justify-content-between align-items-center">
                  <div style="height: 14px; width: 50%; background: rgba(255,255,255,0.08); border-radius: 4px;"></div>
                  <div style="height: 18px; width: 40px; background: rgba(255,255,255,0.08); border-radius: 6px;"></div>
                </div>
                <div class="d-flex justify-content-center align-items-center flex-grow-1 my-4">
                  <div style="width: 48px; height: 48px; border-radius: 50%; background: rgba(255,255,255,0.04);"></div>
                </div>
              </div>
            </div>
          </div>

          <!-- Empty State -->
          <div v-else-if="contents.length === 0 && !isLoading" class="text-center py-5">
            <div class="mb-4 d-flex justify-content-center">
              <div class="add-card-circle-icon cursor-pointer" style="width: 64px; height: 64px;" @click="$router.push({name: 'BonusContentAdd'})">
                <i class="fa fa-plus text-white font-size-24"></i>
              </div>
            </div>
            <h5 class="text-white font-weight-500 mb-2" style="opacity: 0.85;">No bonus content yet</h5>
            <p class="text-muted font-size-14 mb-4" style="max-width: 360px; margin: 0 auto;">
              Share exclusive photos, videos, and downloads for your fans to unlock.
            </p>
            <button type="button" class="cp-btn-primary d-inline-flex align-items-center" @click="$router.push({name: 'BonusContentAdd'})">
              <i class="fa fa-plus me-2 font-size-12"></i> Add First Content
            </button>
          </div>
                  
          <!-- 3-column grid for all content -->
          <div class="content-grid" v-else-if="contents.length">
            <template v-for="(content, index) in contents">
              <div :key="'item-' + index"
                class="grid-cell content-animate"
                :style="{ animationDelay: index * 40 + 'ms' }"
                @click="checkEditOrArchive(index)">
                <!-- Pinned badge -->
                <div v-if="content.pinned" class="grid-badge pinned-badge">📌</div>
                <!-- Archived overlay -->
                <div v-if="!content.active" class="archived-overlay">Archived</div>

                <!-- IMAGE -->
                <img v-if="content.type === 'IMAGE'" :src="index <= allowedIndex ? content.cdnUrl : ''" class="grid-media" :style="getOpacity(content)">
                <template v-else-if="content.type === 'VIDEO'">
                  <video class="grid-media" :src="index <= allowedIndex ? content.cdnUrl : ''" preload="none" muted :style="getOpacity(content)"></video>
                  <div class="play-icon">▶</div>
                </template>
                <!-- FILE / OTHER -->
                <div v-else class="file-tile">
                  <img src="@/assets/images/download.png" style="width:36px;height:36px;opacity:0.7;">
                  <div class="file-name">{{ content.ext }}</div>
                </div>

                <!-- Permanent Top Overlay: Title & Price -->
                <div class="grid-info-overlay d-flex flex-column text-left w-100">
                  <div class="d-flex align-items-start justify-content-between">
                    <!-- Left: Title -->
                    <div class="text-white font-weight-bold font-size-14 text-truncate pe-2" style="text-shadow: 0 1px 3px rgba(0,0,0,0.8); pointer-events: none;" :title="content.description">
                      {{ content.description }}
                    </div>
                    <!-- Right: Price -->
                    <div class="d-flex flex-column align-items-end flex-shrink-0" style="pointer-events: auto;">
                      <div class="px-2 py-1" style="background: rgba(0,0,0,0.65); border-radius: 6px; font-size: 12px; font-weight: 900; color: #ff6ec7; box-shadow: 0 2px 4px rgba(0,0,0,0.2); letter-spacing: 0.5px;">
                        {{ content.price === 0 ? 'Free' : '$' + content.price }}
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Hover overlay (Background darken only) -->
                <div class="grid-hover" style="pointer-events: none; justify-content: flex-end; padding: 12px; align-items: flex-start;" :style="{ background: content.cdnUrl ? 'rgba(0,0,0,0.75)' : 'transparent' }">
                </div>

                <!-- Permanent Bottom Overlay: Likes -->
                <div class="grid-bottom-overlay d-flex align-items-center justify-content-between w-100" style="position: absolute; bottom: 0; left: 0; padding: 12px; z-index: 5; pointer-events: none; background: linear-gradient(to top, rgba(0,0,0,0.7) 0%, transparent 100%);">
                  <!-- Left: Always visible Like button -->
                  <div class="d-flex align-items-center" style="gap: 6px; pointer-events: none;">
                    <i class="fa fa-heart" style="color: #ff6ec7; font-size: 18px; filter: drop-shadow(0 2px 4px rgba(0,0,0,0.5));"></i>
                    <span v-if="content.likedCount > 0" class="text-white font-size-12 font-weight-bold" style="text-shadow: 0 1px 3px rgba(0,0,0,0.8);">{{ content.likedCount }}</span>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <!-- post end -->

          <infinite-loading @infinite="loadData">
            <div slot="no-more"></div>
            <div slot="no-results"></div>
          </infinite-loading>

          <model-edit-archive ref="editArchive" :content="contents[contentIndex]" @archive="archive()" @edit="edit()" @delete="deleteContent()" />

        </div>
      </div>
    </div>
  </section>
</template>

<script>

import {mapActions, mapGetters} from "vuex";

import InfiniteLoading from 'vue-infinite-loading';
import {httpMixin} from "@/mixin/http-mixin";
import HeaderMenu from "@/components/module/influencer/shared/HeaderMenu";
import InfluencerMenu from "@/components/module/influencer/shared/InfluencerMenu";
import InfluencerHeader from "@/components/module/influencer/shared/InfluencerHeader";
import {constructCustomerURL} from "@/common/baseURL-service";
import GlobalMessage from "@/components/module/shared/GlobalMessage";
import {newSubscriptionMixin} from "@/mixin/new-subscription-mixin";
import {SERVICE_CONTENT} from "@/properties/micro-service";
import ModelEditArchive from "@/components/module/influencer/content/ModelEditArchive";
import titleMixin from "../../../../mixin/title-mixin";

export default {
  name: 'BonusContentList',
  title: 'Creator bonus contents',
  mixins: [httpMixin, newSubscriptionMixin, titleMixin],
  components: {
    HeaderMenu, InfluencerMenu,
    InfluencerHeader, GlobalMessage,
    ModelEditArchive, InfiniteLoading
  },
  data() {
    return {
      user: {},
      showSlideBar: false,
      isSubmit: false,
      isVideo: false,
      contents: [],
      contentIndex: null,

      pageNumber: 0,
      noOfItems: 10,
      currentPlayingIndex: null,
      allowedIndex: 5,
      staggerInterval: null
    }
  },
  computed: {
    copyLabel() {
      return this.copied ? 'Copied' : 'Copy';
    },
    pinnedContents() {
      return this.contents.filter(c => c.pinned);
    },
    gridContents() {
      return this.contents.filter(c => !c.pinned && (c.type === 'IMAGE' || c.type === 'VIDEO'));
    },
    fileContents() {
      return this.contents.filter(c => !c.pinned && c.type !== 'IMAGE' && c.type !== 'VIDEO');
    }
  },
  mounted() {
    this.staggerInterval = setInterval(() => {
      if (this.contents && this.allowedIndex < this.contents.length) {
        this.allowedIndex += 1;
      }
    }, 100);
  },
  beforeDestroy() {
    if (this.staggerInterval) {
      clearInterval(this.staggerInterval);
    }
  },
  created() {
    this.user = this.getUser();
    // document.body.style.overflow = 'auto';
  },
  methods: {
    ...mapGetters(['getUser']),
    ...mapActions(['setUser', 'setMessage']),
    loadData($state) {
      console.log('loadData');
      if (!this.user || !this.user.id) {
        $state.complete();
        return;
      }
      let url = `${SERVICE_CONTENT}/api/v1/influencers/${this.user.id}/content/page?pageNumber=${this.pageNumber}&numberOfItems=${this.noOfItems}`;
      this.getData(url, (page) => {
        if (this.pageNumber === 0) {
          if (this.$route.params.isSaved) {
            this.setMessage('UPLOADED.SUCCESSFULLY');
          } else if (this.$route.params.isDeleted) {
            this.setMessage('DELETED.SUCCESSFULLY');
          } else if (this.$route.params.isArchived) {
            this.setMessage('ARCHIVED.SUCCESSFULLY');
          }
        }
        if (!page.empty) {
          this.contents.push(...page.content);
          this.pageNumber += 1;
          $state.loaded();
        } else {
          $state.complete();
          console.log('complete');
        }
      });

    },
    constructCustomerURL,
    getOpacity(content) {
      return content.active ? '' : 'opacity: 0.7;';
    },
    archive() {
      this.$refs.editArchive.hide();
      this.changeContentActiveState(false);
    },
    deleteContent() {
      this.$refs.editArchive.hide();
      let content = this.contents[this.contentIndex];
      let url = `${SERVICE_CONTENT}/api/v1/influencers/${this.user.id}/content/${content.id}`;
      this.getDelete(url, (data) => {
        this.setMessage('DELETED.SUCCESSFULLY');
        this.contents.splice(this.contentIndex, 1);
      });
    },
    unArchive(index) {
      this.contentIndex = index;
      this.changeContentActiveState(true);
    },
    changeContentActiveState(value) {
      let content = this.contents[this.contentIndex];
      content.active = value;
      let url = `${SERVICE_CONTENT}/api/v1/influencers/${this.user.id}/content/${content.id}`;
      this.patchData(url, content, (data) => {
        if (content.active) {
          this.setMessage('UNARCHIVED.SUCCESSFULLY');
        } else {
          this.setMessage('ARCHIVED.SUCCESSFULLY');
        }
      });

    },
    checkEditOrArchive(index) {
      this.contentIndex = index;
      if (this.contents[index].active) {
        //show edit or archive button model
        this.$refs.editArchive.show();
      }

    },
    edit() {
      this.$router.replace({name: 'BonusContentEdit', params: {contentId: this.contents[this.contentIndex].id}});
    },
    slideBar() {
      this.showSlideBar = !this.showSlideBar;
    },
    handlePlay(index) {
      if (this.currentPlayingIndex !== null && this.currentPlayingIndex !== index) {
        const previousVideo = this.$refs.videoElements[this.currentPlayingIndex];
        if (previousVideo) {
          previousVideo.pause();
        }
      }
      this.currentPlayingIndex = index;
    },
  }
}

</script>

<style scoped>
@keyframes fadeSlideIn {
  from { opacity: 0; transform: translateY(12px); }
  to   { opacity: 1; transform: translateY(0); }
}
.content-animate { animation: fadeSlideIn 0.35s ease both; }

.content-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  margin-top: 12px;
}

@media (min-width: 600px) {
  .content-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }
}

@media (min-width: 992px) {
  .content-grid {
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    gap: 20px;
  }
}

.grid-cell {
  position: relative;
  overflow: hidden;
  cursor: pointer;
  background: rgba(18, 18, 22, 0.85);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  aspect-ratio: 4 / 3;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 18px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.45);
  transition: transform 0.25s ease, border-color 0.25s ease;
}

@media (min-width: 768px) {
  .grid-cell {
    aspect-ratio: 1 / 1;
  }
}

.grid-cell:hover {
  transform: translateY(-2px);
  border-color: rgba(229, 59, 185, 0.4);
}

.grid-media {
  position: absolute;
  top: 0; left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  pointer-events: none;
}
.grid-badge {
  position: absolute;
  z-index: 6;
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 8px;
  pointer-events: none;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(8px);
}
.pinned-badge { top: 12px; left: 12px; }

.price-badge {
  top: 12px; right: 12px;
  background: rgba(0,0,0,0.7);
  color: #fff;
  font-weight: 700;
  font-size: 12px;
}
.archived-overlay {
  position: absolute; inset: 0; z-index: 2;
  display: flex; align-items: center; justify-content: center;
  background: rgba(0,0,0,0.55);
  color: #ccc; font-size: 12px; font-weight: 600;
  text-transform: uppercase; letter-spacing: 1px;
  pointer-events: none;
}
.play-icon {
  position: absolute; top: 50%; left: 50%;
  transform: translate(-50%, -50%);
  font-size: 28px;
  color: rgba(255,255,255,0.95);
  text-shadow: 0 2px 8px rgba(0,0,0,0.6);
  pointer-events: none; z-index: 2;
}
.file-tile {
  width: 100%; height: 100%;
  display: flex; flex-direction: column;
  align-items: center; justify-content: center;
  background: #18181c;
}
.file-name {
  margin-top: 8px; font-size: 11px; color: #aaa;
  text-transform: uppercase; font-weight: 600;
}
.grid-hover {
  position: absolute; inset: 0;
  background: rgba(0,0,0,0.65);
  opacity: 0; transition: opacity 0.2s ease;
  display: flex; flex-direction: column;
  align-items: center; justify-content: center;
  z-index: 4; padding: 6px;
}
.grid-cell:hover .grid-hover {
  opacity: 1;
}
.grid-info-overlay {
  position: absolute;
  top: 0; left: 0; right: 0;
  padding: 14px;
  background: linear-gradient(to bottom, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.4) 60%, transparent 100%);
  pointer-events: none;
  z-index: 4;
}
.hover-likes, .hover-desc {
  font-size: 13px; color: #fff; font-weight: 600;
  display: flex; align-items: center; gap: 4px;
}
.hover-desc {
  font-size: 11px; color: #ccc; margin-top: 4px;
  text-align: center; max-height: 30px;
  overflow: hidden; text-overflow: ellipsis;
}

.video-desc-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 12px 10px 8px 10px;
  background: linear-gradient(to top, rgba(0,0,0,0.8), transparent);
  color: white;
  font-size: 13px;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  pointer-events: none;
  z-index: 2;
}

.new-subscribers-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  transition: all 0.2s ease;
}
.new-subscribers-card:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.2);
}
.icon-circle {
  width: 40px; height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #f5d165, #f565c5);
  display: flex; align-items: center; justify-content: center;
  box-shadow: 0 4px 15px rgba(245, 101, 197, 0.3);
}

.clean-url-box {
  background: #1e1e1e;
  border: 1px solid #333;
  border-radius: 50px;
}
.clean-url-box .copy-btn {
  background: #2a2a2a;
  border-color: #444;
  color: #fff;
}
.clean-url-box .copy-btn:hover {
  background: #333;
}

.add-card-circle-icon {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: linear-gradient(135deg, #F3DA6B 0%, #E53BB9 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 20px rgba(229, 59, 185, 0.4);
  transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.add-card-circle-icon:hover {
  transform: scale(1.12) rotate(90deg);
}
</style>
